var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#D60B13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.0514V25.0514M24 29.0514H24.01M22.29 15.9114L13.82 30.0514C13.6454 30.3538 13.553 30.6967 13.552 31.0459C13.551 31.3951 13.6415 31.7385 13.8144 32.0419C13.9874 32.3453 14.2367 32.5981 14.5377 32.7752C14.8387 32.9523 15.1808 33.0475 15.53 33.0514H32.47C32.8192 33.0475 33.1613 32.9523 33.4623 32.7752C33.7633 32.5981 34.0127 32.3453 34.1856 32.0419C34.3585 31.7385 34.449 31.3951 34.448 31.0459C34.4471 30.6967 34.3547 30.3538 34.18 30.0514L25.71 15.9114C25.5318 15.6175 25.2807 15.3745 24.9812 15.2059C24.6817 15.0372 24.3438 14.9486 24 14.9486C23.6563 14.9486 23.3184 15.0372 23.0188 15.2059C22.7193 15.3745 22.4683 15.6175 22.29 15.9114Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.f161a883110b264e5c00c2b10c0fce57.svg";
export { ForwardRef as ReactComponent };